function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["analyticsName", "trackBoxImpression", "trackButtonImpressions", "isOpen", "desktopAndTabletSize", "height", "minHeight", "mobileSize", "overflow", "shouldCloseOnOverlayClick", "onRequestClose", "overlayBackgroundColor", "hasPadding", "isCloseSticky", "light", "top", "design", "id", "themeProps"];
function cov_24vv09do11() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Modal/Modal.tsx";
  var hash = "6afe4e8a1eea07c505e78e41777a7c9f938539e2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Modal/Modal.tsx",
    statementMap: {
      "0": {
        start: {
          line: 23,
          column: 29
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "1": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 24,
          column: 39
        }
      },
      "2": {
        start: {
          line: 83,
          column: 43
        },
        end: {
          line: 248,
          column: 1
        }
      },
      "3": {
        start: {
          line: 105,
          column: 40
        },
        end: {
          line: 105,
          column: 55
        }
      },
      "4": {
        start: {
          line: 106,
          column: 23
        },
        end: {
          line: 109,
          column: 3
        }
      },
      "5": {
        start: {
          line: 107,
          column: 11
        },
        end: {
          line: 107,
          column: 56
        }
      },
      "6": {
        start: {
          line: 110,
          column: 38
        },
        end: {
          line: 110,
          column: 49
        }
      },
      "7": {
        start: {
          line: 111,
          column: 2
        },
        end: {
          line: 111,
          column: 32
        }
      },
      "8": {
        start: {
          line: 113,
          column: 42
        },
        end: {
          line: 113,
          column: 44
        }
      },
      "9": {
        start: {
          line: 114,
          column: 2
        },
        end: {
          line: 147,
          column: 3
        }
      },
      "10": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 126,
          column: 6
        }
      },
      "11": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 146,
          column: 6
        }
      },
      "12": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 154,
          column: 12
        }
      },
      "13": {
        start: {
          line: 155,
          column: 20
        },
        end: {
          line: 155,
          column: 97
        }
      },
      "14": {
        start: {
          line: 157,
          column: 2
        },
        end: {
          line: 247,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 23,
            column: 29
          },
          end: {
            line: 23,
            column: 30
          }
        },
        loc: {
          start: {
            line: 23,
            column: 67
          },
          end: {
            line: 25,
            column: 1
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 83,
            column: 43
          },
          end: {
            line: 83,
            column: 44
          }
        },
        loc: {
          start: {
            line: 104,
            column: 6
          },
          end: {
            line: 248,
            column: 1
          }
        },
        line: 104
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 107,
            column: 5
          }
        },
        loc: {
          start: {
            line: 107,
            column: 11
          },
          end: {
            line: 107,
            column: 56
          }
        },
        line: 107
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 87,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 87,
            column: 11
          },
          end: {
            line: 87,
            column: 16
          }
        }],
        line: 87
      },
      "1": {
        loc: {
          start: {
            line: 88,
            column: 2
          },
          end: {
            line: 88,
            column: 29
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 88,
            column: 25
          },
          end: {
            line: 88,
            column: 29
          }
        }],
        line: 88
      },
      "2": {
        loc: {
          start: {
            line: 90,
            column: 2
          },
          end: {
            line: 90,
            column: 17
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 90,
            column: 14
          },
          end: {
            line: 90,
            column: 17
          }
        }],
        line: 90
      },
      "3": {
        loc: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 91,
            column: 15
          },
          end: {
            line: 91,
            column: 27
          }
        }],
        line: 91
      },
      "4": {
        loc: {
          start: {
            line: 92,
            column: 2
          },
          end: {
            line: 92,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 92,
            column: 13
          },
          end: {
            line: 92,
            column: 19
          }
        }],
        line: 92
      },
      "5": {
        loc: {
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 93,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 93,
            column: 30
          },
          end: {
            line: 93,
            column: 34
          }
        }],
        line: 93
      },
      "6": {
        loc: {
          start: {
            line: 96,
            column: 2
          },
          end: {
            line: 96,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 96,
            column: 15
          },
          end: {
            line: 96,
            column: 19
          }
        }],
        line: 96
      },
      "7": {
        loc: {
          start: {
            line: 97,
            column: 17
          },
          end: {
            line: 97,
            column: 39
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 97,
            column: 34
          },
          end: {
            line: 97,
            column: 39
          }
        }],
        line: 97
      },
      "8": {
        loc: {
          start: {
            line: 98,
            column: 9
          },
          end: {
            line: 98,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 98,
            column: 18
          },
          end: {
            line: 98,
            column: 23
          }
        }],
        line: 98
      },
      "9": {
        loc: {
          start: {
            line: 114,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        }, {
          start: {
            line: 127,
            column: 9
          },
          end: {
            line: 147,
            column: 3
          }
        }],
        line: 114
      },
      "10": {
        loc: {
          start: {
            line: 117,
            column: 17
          },
          end: {
            line: 117,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 117,
            column: 47
          },
          end: {
            line: 117,
            column: 54
          }
        }, {
          start: {
            line: 117,
            column: 57
          },
          end: {
            line: 117,
            column: 77
          }
        }],
        line: 117
      },
      "11": {
        loc: {
          start: {
            line: 120,
            column: 14
          },
          end: {
            line: 120,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 120,
            column: 44
          },
          end: {
            line: 120,
            column: 50
          }
        }, {
          start: {
            line: 120,
            column: 53
          },
          end: {
            line: 120,
            column: 69
          }
        }],
        line: 120
      },
      "12": {
        loc: {
          start: {
            line: 120,
            column: 53
          },
          end: {
            line: 120,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 120,
            column: 53
          },
          end: {
            line: 120,
            column: 59
          }
        }, {
          start: {
            line: 120,
            column: 63
          },
          end: {
            line: 120,
            column: 69
          }
        }],
        line: 120
      },
      "13": {
        loc: {
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 122,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 122,
            column: 38
          },
          end: {
            line: 122,
            column: 39
          }
        }, {
          start: {
            line: 122,
            column: 42
          },
          end: {
            line: 122,
            column: 89
          }
        }],
        line: 122
      },
      "14": {
        loc: {
          start: {
            line: 125,
            column: 17
          },
          end: {
            line: 125,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 125,
            column: 47
          },
          end: {
            line: 125,
            column: 53
          }
        }, {
          start: {
            line: 125,
            column: 56
          },
          end: {
            line: 125,
            column: 66
          }
        }],
        line: 125
      },
      "15": {
        loc: {
          start: {
            line: 130,
            column: 17
          },
          end: {
            line: 130,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 130,
            column: 57
          },
          end: {
            line: 130,
            column: 64
          }
        }, {
          start: {
            line: 130,
            column: 67
          },
          end: {
            line: 130,
            column: 87
          }
        }],
        line: 130
      },
      "16": {
        loc: {
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 139,
            column: 19
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 134,
            column: 12
          },
          end: {
            line: 134,
            column: 19
          }
        }, {
          start: {
            line: 135,
            column: 12
          },
          end: {
            line: 139,
            column: 19
          }
        }],
        line: 133
      },
      "17": {
        loc: {
          start: {
            line: 135,
            column: 12
          },
          end: {
            line: 139,
            column: 19
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 136,
            column: 12
          },
          end: {
            line: 138,
            column: 21
          }
        }, {
          start: {
            line: 139,
            column: 12
          },
          end: {
            line: 139,
            column: 19
          }
        }],
        line: 135
      },
      "18": {
        loc: {
          start: {
            line: 136,
            column: 12
          },
          end: {
            line: 138,
            column: 21
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 137,
            column: 14
          },
          end: {
            line: 137,
            column: 21
          }
        }, {
          start: {
            line: 138,
            column: 14
          },
          end: {
            line: 138,
            column: 21
          }
        }],
        line: 136
      },
      "19": {
        loc: {
          start: {
            line: 140,
            column: 14
          },
          end: {
            line: 140,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 140,
            column: 54
          },
          end: {
            line: 140,
            column: 61
          }
        }, {
          start: {
            line: 140,
            column: 64
          },
          end: {
            line: 140,
            column: 80
          }
        }],
        line: 140
      },
      "20": {
        loc: {
          start: {
            line: 140,
            column: 64
          },
          end: {
            line: 140,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 140,
            column: 64
          },
          end: {
            line: 140,
            column: 70
          }
        }, {
          start: {
            line: 140,
            column: 74
          },
          end: {
            line: 140,
            column: 80
          }
        }],
        line: 140
      },
      "21": {
        loc: {
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 142,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 142,
            column: 72
          },
          end: {
            line: 142,
            column: 89
          }
        }, {
          start: {
            line: 142,
            column: 92
          },
          end: {
            line: 142,
            column: 93
          }
        }],
        line: 142
      },
      "22": {
        loc: {
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 142,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 142,
            column: 8
          },
          end: {
            line: 142,
            column: 28
          }
        }, {
          start: {
            line: 142,
            column: 32
          },
          end: {
            line: 142,
            column: 69
          }
        }],
        line: 142
      },
      "23": {
        loc: {
          start: {
            line: 143,
            column: 11
          },
          end: {
            line: 143,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 143,
            column: 51
          },
          end: {
            line: 143,
            column: 56
          }
        }, {
          start: {
            line: 143,
            column: 59
          },
          end: {
            line: 143,
            column: 72
          }
        }],
        line: 143
      },
      "24": {
        loc: {
          start: {
            line: 143,
            column: 59
          },
          end: {
            line: 143,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 143,
            column: 59
          },
          end: {
            line: 143,
            column: 62
          }
        }, {
          start: {
            line: 143,
            column: 66
          },
          end: {
            line: 143,
            column: 72
          }
        }],
        line: 143
      },
      "25": {
        loc: {
          start: {
            line: 145,
            column: 17
          },
          end: {
            line: 145,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 145,
            column: 57
          },
          end: {
            line: 145,
            column: 63
          }
        }, {
          start: {
            line: 145,
            column: 66
          },
          end: {
            line: 145,
            column: 76
          }
        }],
        line: 145
      },
      "26": {
        loc: {
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 154,
            column: 12
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 151,
            column: 8
          },
          end: {
            line: 151,
            column: 50
          }
        }, {
          start: {
            line: 152,
            column: 8
          },
          end: {
            line: 154,
            column: 12
          }
        }],
        line: 150
      },
      "27": {
        loc: {
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 150,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 150,
            column: 26
          }
        }, {
          start: {
            line: 150,
            column: 30
          },
          end: {
            line: 150,
            column: 58
          }
        }],
        line: 150
      },
      "28": {
        loc: {
          start: {
            line: 152,
            column: 8
          },
          end: {
            line: 154,
            column: 12
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 153,
            column: 8
          },
          end: {
            line: 153,
            column: 32
          }
        }, {
          start: {
            line: 154,
            column: 8
          },
          end: {
            line: 154,
            column: 12
          }
        }],
        line: 152
      },
      "29": {
        loc: {
          start: {
            line: 155,
            column: 20
          },
          end: {
            line: 155,
            column: 97
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 155,
            column: 37
          },
          end: {
            line: 155,
            column: 41
          }
        }, {
          start: {
            line: 155,
            column: 44
          },
          end: {
            line: 155,
            column: 97
          }
        }],
        line: 155
      },
      "30": {
        loc: {
          start: {
            line: 155,
            column: 44
          },
          end: {
            line: 155,
            column: 97
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 155,
            column: 68
          },
          end: {
            line: 155,
            column: 87
          }
        }, {
          start: {
            line: 155,
            column: 90
          },
          end: {
            line: 155,
            column: 97
          }
        }],
        line: 155
      },
      "31": {
        loc: {
          start: {
            line: 164,
            column: 18
          },
          end: {
            line: 164,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 164,
            column: 24
          },
          end: {
            line: 164,
            column: 32
          }
        }, {
          start: {
            line: 164,
            column: 35
          },
          end: {
            line: 164,
            column: 41
          }
        }],
        line: 164
      },
      "32": {
        loc: {
          start: {
            line: 178,
            column: 27
          },
          end: {
            line: 178,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 178,
            column: 27
          },
          end: {
            line: 178,
            column: 49
          }
        }, {
          start: {
            line: 178,
            column: 53
          },
          end: {
            line: 178,
            column: 77
          }
        }],
        line: 178
      },
      "33": {
        loc: {
          start: {
            line: 204,
            column: 9
          },
          end: {
            line: 230,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 204,
            column: 10
          },
          end: {
            line: 204,
            column: 25
          }
        }, {
          start: {
            line: 204,
            column: 29
          },
          end: {
            line: 204,
            column: 51
          }
        }, {
          start: {
            line: 205,
            column: 10
          },
          end: {
            line: 229,
            column: 13
          }
        }],
        line: 204
      },
      "34": {
        loc: {
          start: {
            line: 207,
            column: 29
          },
          end: {
            line: 207,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 207,
            column: 50
          },
          end: {
            line: 207,
            column: 63
          }
        }, {
          start: {
            line: 207,
            column: 66
          },
          end: {
            line: 207,
            column: 75
          }
        }],
        line: 207
      },
      "35": {
        loc: {
          start: {
            line: 225,
            column: 21
          },
          end: {
            line: 225,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 225,
            column: 46
          },
          end: {
            line: 225,
            column: 63
          }
        }, {
          start: {
            line: 225,
            column: 66
          },
          end: {
            line: 225,
            column: 68
          }
        }],
        line: 225
      },
      "36": {
        loc: {
          start: {
            line: 228,
            column: 13
          },
          end: {
            line: 228,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 228,
            column: 13
          },
          end: {
            line: 228,
            column: 24
          }
        }, {
          start: {
            line: 228,
            column: 28
          },
          end: {
            line: 228,
            column: 39
          }
        }],
        line: 228
      },
      "37": {
        loc: {
          start: {
            line: 232,
            column: 13
          },
          end: {
            line: 232,
            column: 31
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 232,
            column: 26
          },
          end: {
            line: 232,
            column: 27
          }
        }, {
          start: {
            line: 232,
            column: 30
          },
          end: {
            line: 232,
            column: 31
          }
        }],
        line: 232
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0],
      "6": [0],
      "7": [0],
      "8": [0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6afe4e8a1eea07c505e78e41777a7c9f938539e2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_24vv09do11 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_24vv09do11();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.concat.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/** @jsx jsx */
import React, { useCallback, useState } from 'react';
import ReactModal from 'react-modal';
import { jsx } from '@emotion/react';
import { Box, Button, Divider, Icon } from "../../core/index.mjs";
import { useDevice } from "../../hooks/useMedia.mjs";
import { radii, shadows } from "../../theme/eero/index.mjs";
import { ThemedLite } from "../../theme/ODThemeLite.mjs";
import { getNavigationBarTitleId, NavigationBar } from "./NavigationBar.mjs";
import { useDisabledBodyScroll } from "./shared.mjs";

/** @deprecated */
// React Modal hides other page content while modal is open which complies with accessibility standards.
// https://reactcommunity.org/react-modal/accessibility/#app-element
cov_24vv09do11().s[0]++;
export var setAppElement = function setAppElement(appElement) {
  cov_24vv09do11().f[0]++;
  cov_24vv09do11().s[1]++;
  ReactModal.setAppElement(appElement);
};

/* To meet accessibility standards, the Modal component must receive either headerProps.title, aria-labelledby, or aria-label. */
/**
 * @deprecated Use FullScreenModal, Popover, or ContextSheet instead.
 */
cov_24vv09do11().s[2]++;
export var Modal = function Modal(_ref) {
  var analyticsName = _ref.analyticsName,
    trackBoxImpression = _ref.trackBoxImpression,
    trackButtonImpressions = _ref.trackButtonImpressions,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? (cov_24vv09do11().b[0][0]++, false) : _ref$isOpen,
    _ref$desktopAndTablet = _ref.desktopAndTabletSize,
    desktopAndTabletSize = _ref$desktopAndTablet === void 0 ? (cov_24vv09do11().b[1][0]++, 'sm') : _ref$desktopAndTablet,
    height = _ref.height,
    _ref$minHeight = _ref.minHeight,
    minHeight = _ref$minHeight === void 0 ? (cov_24vv09do11().b[2][0]++, 200) : _ref$minHeight,
    _ref$mobileSize = _ref.mobileSize,
    mobileSize = _ref$mobileSize === void 0 ? (cov_24vv09do11().b[3][0]++, 'fullScreen') : _ref$mobileSize,
    _ref$overflow = _ref.overflow,
    overflow = _ref$overflow === void 0 ? (cov_24vv09do11().b[4][0]++, 'auto') : _ref$overflow,
    _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick,
    shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? (cov_24vv09do11().b[5][0]++, true) : _ref$shouldCloseOnOve,
    onRequestClose = _ref.onRequestClose,
    overlayBackgroundColor = _ref.overlayBackgroundColor,
    _ref$hasPadding = _ref.hasPadding,
    hasPadding = _ref$hasPadding === void 0 ? (cov_24vv09do11().b[6][0]++, true) : _ref$hasPadding,
    _ref$isCloseSticky = _ref.isCloseSticky,
    _isCloseSticky = _ref$isCloseSticky === void 0 ? (cov_24vv09do11().b[7][0]++, false) : _ref$isCloseSticky,
    _ref$light = _ref.light,
    _light = _ref$light === void 0 ? (cov_24vv09do11().b[8][0]++, false) : _ref$light,
    top = _ref.top,
    design = _ref.design,
    id = _ref.id,
    themeProps = _ref.themeProps,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_24vv09do11().f[1]++;
  var _ref2 = (cov_24vv09do11().s[3]++, useState(false)),
    _ref3 = _slicedToArray(_ref2, 2),
    showDivider = _ref3[0],
    setShowDivider = _ref3[1];
  var handleScroll = (cov_24vv09do11().s[4]++, useCallback(function (e) {
    cov_24vv09do11().f[2]++;
    cov_24vv09do11().s[5]++;
    return setShowDivider(e.currentTarget.scrollTop > 0);
  }, []));
  var _ref4 = (cov_24vv09do11().s[6]++, useDevice()),
    isMobile = _ref4.isMobile,
    isSmallTablet = _ref4.isSmallTablet;
  cov_24vv09do11().s[7]++;
  useDisabledBodyScroll(isOpen);
  var contentStyle = (cov_24vv09do11().s[8]++, {});
  cov_24vv09do11().s[9]++;
  if (isMobile) {
    var _ref5;
    cov_24vv09do11().b[9][0]++;
    cov_24vv09do11().s[10]++;
    contentStyle = {
      position: 'fixed',
      maxHeight: mobileSize === 'fullScreen' ? (cov_24vv09do11().b[10][0]++, '100vh') : (cov_24vv09do11().b[10][1]++, 'calc(100vh - 48px)'),
      maxWidth: '100vw',
      width: '100vw',
      height: mobileSize === 'fullScreen' ? (cov_24vv09do11().b[11][0]++, '100%') : (cov_24vv09do11().b[11][1]++, (_ref5 = (cov_24vv09do11().b[12][0]++, height)) !== null && _ref5 !== void 0 ? _ref5 : (cov_24vv09do11().b[12][1]++, 'auto')),
      borderRadius: mobileSize === 'fullScreen' ? (cov_24vv09do11().b[13][0]++, 0) : (cov_24vv09do11().b[13][1]++, "".concat(radii.semiRounded, " ").concat(radii.semiRounded, " 0 0")),
      bottom: 0,
      top: 'auto',
      boxShadow: mobileSize === 'fullScreen' ? (cov_24vv09do11().b[14][0]++, 'none') : (cov_24vv09do11().b[14][1]++, shadows.z2)
    };
  } else {
    var _ref6, _ref7;
    cov_24vv09do11().b[9][1]++;
    cov_24vv09do11().s[11]++;
    contentStyle = {
      position: 'relative',
      maxHeight: desktopAndTabletSize === 'fullScreen' ? (cov_24vv09do11().b[15][0]++, '100vh') : (cov_24vv09do11().b[15][1]++, 'calc(100vh - 48px)'),
      maxWidth: '100vw',
      width: desktopAndTabletSize === 'sm' ? (cov_24vv09do11().b[16][0]++, '512px') : (cov_24vv09do11().b[16][1]++, desktopAndTabletSize === 'lg' ? (cov_24vv09do11().b[17][0]++, isSmallTablet ? (cov_24vv09do11().b[18][0]++, '720px') : (cov_24vv09do11().b[18][1]++, '960px')) : (cov_24vv09do11().b[17][1]++, '100vw')),
      height: desktopAndTabletSize === 'fullScreen' ? (cov_24vv09do11().b[19][0]++, '100vh') : (cov_24vv09do11().b[19][1]++, (_ref6 = (cov_24vv09do11().b[20][0]++, height)) !== null && _ref6 !== void 0 ? _ref6 : (cov_24vv09do11().b[20][1]++, 'auto')),
      borderRadius: (cov_24vv09do11().b[22][0]++, design === 'rounded') || (cov_24vv09do11().b[22][1]++, desktopAndTabletSize !== 'fullScreen') ? (cov_24vv09do11().b[21][0]++, radii.semiRounded) : (cov_24vv09do11().b[21][1]++, 0),
      top: desktopAndTabletSize === 'fullScreen' ? (cov_24vv09do11().b[23][0]++, '0px') : (cov_24vv09do11().b[23][1]++, (_ref7 = (cov_24vv09do11().b[24][0]++, top)) !== null && _ref7 !== void 0 ? _ref7 : (cov_24vv09do11().b[24][1]++, 'auto')),
      bottom: 'auto',
      boxShadow: desktopAndTabletSize === 'fullScreen' ? (cov_24vv09do11().b[25][0]++, 'none') : (cov_24vv09do11().b[25][1]++, shadows.z2)
    };
  }
  var ariaLabelledBy = (cov_24vv09do11().s[12]++, (cov_24vv09do11().b[27][0]++, 'headerProps' in props) && (cov_24vv09do11().b[27][1]++, 'title' in props.headerProps) ? (cov_24vv09do11().b[26][0]++, getNavigationBarTitleId(props.headerProps)) : (cov_24vv09do11().b[26][1]++, 'aria-labelledby' in props ? (cov_24vv09do11().b[28][0]++, props['aria-labelledby']) : (cov_24vv09do11().b[28][1]++, null)));
  var ariaLabel = (cov_24vv09do11().s[13]++, ariaLabelledBy ? (cov_24vv09do11().b[29][0]++, null) : (cov_24vv09do11().b[29][1]++, 'aria-label' in props ? (cov_24vv09do11().b[30][0]++, props['aria-label']) : (cov_24vv09do11().b[30][1]++, 'Modal')));
  cov_24vv09do11().s[14]++;
  return jsx(ReactModal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    style: {
      content: _objectSpread({
        margin: top ? (cov_24vv09do11().b[31][0]++, '0 auto') : (cov_24vv09do11().b[31][1]++, 'auto'),
        overflow: overflow,
        minHeight: minHeight,
        padding: 0,
        left: 'auto',
        right: 'auto',
        border: 'none',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'start'
      }, contentStyle),
      overlay: {
        display: 'flex',
        backgroundColor: (cov_24vv09do11().b[32][0]++, overlayBackgroundColor) || (cov_24vv09do11().b[32][1]++, 'rgba(34, 34, 34, 0.33)'),
        zIndex: 999
      }
    }
    /*
      Accessibility note: Aria-model indicates the presence of a modal element
      https://www.w3.org/TR/wai-aria-1.2/#aria-modal
    */,
    "aria-modal": isOpen
    /*
      Accessibility note: use the contentLabel prop to provide a label for the modal content
      If the modal is already labeled with visible text, you should specify the element including the label with the aria-labelledby attribute.
      https://reactcommunity.org/react-modal/accessibility/#aria-attributes
      To set aria-labelledby, either (1) pass headerProps.title and let this component set aria-labelledby for you, or (2) pass ariaLabelledBy
      and set it to the id of your custom label
    */,
    contentLabel: ariaLabel,
    aria: {
      labelledby: ariaLabelledBy
    }
  }, jsx(ThemedLite, themeProps, ((cov_24vv09do11().b[33][0]++, props.showClose) || (cov_24vv09do11().b[33][1]++, 'headerProps' in props)) && (cov_24vv09do11().b[33][2]++, jsx(React.Fragment, null, jsx(Box, {
    analyticsName: trackBoxImpression ? (cov_24vv09do11().b[34][0]++, analyticsName) : (cov_24vv09do11().b[34][1]++, undefined),
    trackImpression: trackBoxImpression,
    flexGrow: 0,
    inViewThreshold: 0
  }, jsx(NavigationBar, _extends({
    rightComponent: jsx(Button, {
      id: "modal-close-button",
      onClick: onRequestClose,
      variant: "icon",
      analyticsName: "".concat(analyticsName, "-close"),
      trackImpression: trackButtonImpressions,
      "aria-label": "Close"
    }, jsx(Icon, {
      name: "close",
      size: 16,
      "aria-hidden": "true"
    }))
  }, 'headerProps' in props ? (cov_24vv09do11().b[35][0]++, props.headerProps) : (cov_24vv09do11().b[35][1]++, {})))), (cov_24vv09do11().b[36][0]++, showDivider) && (cov_24vv09do11().b[36][1]++, jsx(Divider, null)))), jsx(Box, {
    p: hasPadding ? (cov_24vv09do11().b[37][0]++, 7) : (cov_24vv09do11().b[37][1]++, 0),
    flexGrow: 1,
    overflowY: "scroll",
    sx: {
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      msOverflowStyle: 'none',
      scrollbarWidth: 'none'
    },
    overflow: overflow,
    onScroll: handleScroll
  }, props.children)));
};
export default Modal;